import React from 'react';
import SpecDropdownSelect from './SpecDropdownSelect';
import SpecDateInput from './SpecDateInput';
import { getInputTypeForSpec } from '../utils/productRegistrationConfig';

/**
 * 제품 등록·수정 사양 값 입력 (드롭다운 / 직접입력 / 날짜)
 */
const SpecFieldInput = ({
    spec,
    productType,
    productRegistrationConfig,
    value,
    onChange,
    specDropdownOptions = [],
    allowAddDropdownOption = false,
    onAddDropdownOption,
    inputType: inputTypeProp,
    className = 'field-input',
    disabled = false,
}) => {
    const inputType = inputTypeProp
        || getInputTypeForSpec(spec, productType, productRegistrationConfig)
        || spec?.inputType
        || 'dropdown';
    const title = String(spec?.title || '').trim();

    if (inputType === 'text') {
        return (
            <input
                className={className}
                type="text"
                value={value ?? ''}
                onChange={(e) => onChange(e.target.value)}
                placeholder={title ? `${title} 입력` : '입력'}
                disabled={disabled}
            />
        );
    }

    if (inputType === 'date') {
        return (
            <SpecDateInput
                className={`${className} spec-date-input`.trim()}
                value={value}
                onChange={onChange}
                disabled={disabled}
                title={title ? `${title} 날짜 선택` : '날짜 선택'}
            />
        );
    }

    return (
        <SpecDropdownSelect
            className={className}
            specTitle={title}
            value={value}
            onChange={onChange}
            options={specDropdownOptions}
            disabled={disabled}
            allowAddOption={allowAddDropdownOption}
            onAddDropdownOption={onAddDropdownOption}
        />
    );
};

export default SpecFieldInput;
